/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/no-unescaped-entities */
import { PRODUCTS_INDEX } from '@constant/common';
import { ORDER_REQUESTED } from '@constant/order';
import { PRODUCT } from '@constant/types';
import { updateUserData } from '@context/actions/user';
import Backdrop from '@material-ui/core/Backdrop';
import AddressModal from '@module/addressModal';
import ConfirmationModal from '@module/confirmationModal';
import PaymentVendorModal from '@module/paymentVendorModal';
import UserRegistrationModal from '@module/userRegistration';
import { getUserByTenantAndMobile } from '@storeData/user';
import { Stripe, StripeElementsOptionsClientSecret, loadStripe } from '@stripe/stripe-js';
import OrderConfirmation from '@template/orderConfirmation';
import StripePaymentModal from '@template/stripe/StripePaymentModal';
import { APISERVICE } from '@util/apiService/RestClient';
import { navigateTo } from '@util/routerService';
import { hasPaymentGateway, isActiveAtBinaryIndex, processAppliedTaxes } from '@util/utils';
import { windowRef } from '@util/window';
import { disableLoader, enableLoader, showError, updateCurrentPage, updatePdpItem } from 'app/redux/actions';
import { replaceOrderIitems, syncLocalStorageOrder } from "app/redux/actions/order";
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from 'react-redux';

import {
  AiOutlineHome,
  BiArrowBack,
  CgWorkAlt,
  CloseIcon,
  FaUserEdit,
  GrFormLocation,
  GrLocation,
  IconFrame,
  MdAddLocation,
  MdDirectionsRun,
  MdEditLocation,
  RiTakeawayLine,
} from '@element/icons';
interface PaymentGateway {
    key: string;
    redirectUrl: string;
}
interface StripeValues {
    options: StripeElementsOptionsClientSecret;
    promise: Promise<Stripe>;
    paymentIntentId: string;
    redirectUrl: any,
    order?: any,
    address?: any,
    user?: any
}

function CheckoutPage() {
    const [pricingBreakdown, setpricingBreakdown] = useState({ total: 0, subTotal: 0, appliedTaxes: [] });
    const dispatch = useDispatch();
    const cartItems = useSelector((state: any) => state.orderItems);
    const storeData = useSelector((state: any) => state.store.storeData);
    const { configData, keywords } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const { gupshupConfig } = configData?.storeConfig;
    const store = useSelector((state: any) => state);
    const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
    const [cookie, setCookie] = useCookies();
    const [userData, setUserCookie] = useState(cookie['user']);
    const [activeGroup, setActiveGroup] = useState(cookie['grp']);
    const [orderInstruction, setOrderInstruction] = useState('')
    const [showOrderConfirmation, setShowOrderConfirmation] = useState(false);
    const [orderType, setOrderType] = useState('delivery');
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState<any>('');
    const [selectedAddressType, setSelectedAddressType] = useState('Home');
    const [selectedAddressToEdit, setSelectedAddressToEdit] = useState(null);
    const [orderData, setOrderData] = useState(null);
    const [showOrderingOff, setShowOrderingOff] = useState(false);
    const [openUserUpdationModal, setOpenUserUpdationModal] = useState(false);
    const [showTotalBreakdownPopup, setShowTotalBreakdownPopup] = useState(false);
    const [paymentGatewayList, setPaymentGatwayList] = useState<any[]>([]);
    const [openCcavenueModal, setopenCcavenueModal] = useState({ active: false, link: "" })
    const [openPaymentVendorModal, setOpenPaymentVendorModal] = useState(false);
    const [stripeModalDetails, setStripeModalDetails] = useState<StripeValues>({
        options: {
            clientSecret: "",
            appearance: {
                theme: 'stripe',
                labels: 'floating',
            }
        },
        promise: undefined,
        paymentIntentId: "",
        redirectUrl: ""
    });

    const [globalPaymentsModalDetails, setGlobalPaymentsModalDetails] = useState<any>({
        accessToken: "",
        reference: ""
    });
    const storeMetaData = useSelector((state: any) => state.store ? state.store.storeMetaData : null);
    const whatsappTemplates = store.whatsappTemplates;
    const basicConfig = configData?.storeConfig?.basicConfig
    const [userAddresses, setUserAddresses] = useState([
        { type: 'Home', value: null, isNew: false, isEdited: false, icon: <AiOutlineHome /> },
        { type: 'Work', value: null, isNew: false, isEdited: false, icon: <CgWorkAlt /> },
        { type: 'Other', value: null, isNew: false, isEdited: false, icon: <GrLocation /> },
    ])
    const [uniqueRecordIdentifier, setUniqueRecordIdentifier] = useState<number>(new Date().getTime());
    const languageData: any = store.languageKeywords
    const activeLanguage: any = store.activeLanguage
    useEffect(() => {
        APISERVICE.GET(process.env.NEXT_PUBLIC_PAYMENT_VENDOR + `?tenantId=${storeMetaData.tenantId}&storeId=${storeMetaData.id}`)
            .then((resp) => {
                if (!resp.data) {
                    // INSERT ERROR MESSAGE HERE
                    console.error("Unable to load payment configurations")
                    return;
                }
                // let gateways: { [key: string]: PaymentGateway } = { [resp.data[0].toLowerCase()]: { key: resp.data[1], redirectUrl: resp.data[2] } };
                setPaymentGatwayList(resp.data.data);
                const stripePaymode = resp.data.data?.find((paymode) => paymode.name == "Stripe");
                if (stripePaymode) {
                    setStripeModalDetails({ ...stripeModalDetails, ...stripePaymode, promise: loadStripe(stripePaymode.key) })
                }
            }).catch((err) => {
                console.error(err)
            })
    }, []);

    useEffect(() => {
        setActiveGroup(cookie['grp'])
        if (cookie['user']) {
            setUserCookie(cookie['user']);
            dispatch(updateUserData(cookie['user']))
        }
    }, [cookie])

    useEffect(() => {
        if (windowRef) {
            localStorage.removeItem("payment_type");
            dispatch(syncLocalStorageOrder());
            dispatch(updatePdpItem(null));
            if (userData) {
                getUserDetails(userData.mobileNo).then((res) => {
                    setUserCookie(res);
                    setCookie("user", res, { //user registration fields
                        path: "/",
                        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                        sameSite: true,
                    })
                    dispatch(updateUserData(res))
                })
            } else {
                navigateTo('home');
            }
        }
    }, [windowRef])

    useEffect(() => {
        if (userData && configData.deliveryOn && !openUserUpdationModal) {

            if (userData?.addressList) {
                const userAddressesCopy = [...userAddresses];
                userAddressesCopy.map((userAdd) => {
                    userData.addressList.map((data) => {
                        if (userAdd.type == data.type) {
                            userAdd.value = data;
                        }
                    })
                })
                const isAnyAddAvl = userAddressesCopy.filter((data) => data.value && data.value.line);
                if (isAnyAddAvl.length != 0) {
                    setSelectedAddressType(isAnyAddAvl[0].type);
                    setSelectedAddress(isAnyAddAvl[0].value)
                } else {
                    setOpenAddressModal(true);
                }
                setUserAddresses(userAddressesCopy);
            } else {
                setActiveAddressType(userAddresses[0]);
                // setOpenAddressModal(true);
            }
        }
    }, [userData])

    useEffect(() => {
        if (cartItems && cartItems.length) {
            let total: any = 0;
            let subTotal: any = 0;
            let appliedTaxes: any[] = [];
            cartItems.map((cartItem) => {
                let applicablePrice: any = (Boolean(cartItem?.excludeFromDiscount) ? cartItem.price : (cartItem.salePrice || cartItem.price)) * cartItem.quantity;
                subTotal += parseFloat(applicablePrice);
                total += parseFloat(applicablePrice);
                appliedTaxes = calculateTaxes(appliedTaxes, applicablePrice, cartItem.taxCharges)
            })
            appliedTaxes.map((taxData: any) => {
                if (!taxData.isInclusive) total = Number((total + taxData.total).toFixed(2));
            })
            setpricingBreakdown({ total, subTotal, appliedTaxes });
        }
    }, [cartItems])

    useEffect(() => {
        if (configData) {
            if (!configData.deliveryOn) setOrderType('pickup');
        }
    }, [configData])

    const handleOrderConfirmationMOdalResponse = () => {
        navigateTo('home');
    }

    const calculateTaxes = (appliedTaxes, taxebalePrice: any, taxCharges) => {
        const hasItemTax = Boolean(taxCharges?.length);
        const taxesToProcess = hasItemTax ? taxCharges : (configData.txchConfig || []);
        const filteredTax = taxesToProcess.filter(taxData =>
            taxData.active && (hasItemTax || (isActiveAtBinaryIndex(taxData.applyOn, PRODUCTS_INDEX) && !taxData.charge)));

        return processAppliedTaxes(filteredTax, taxebalePrice, appliedTaxes);
    }

    const createOrder = (user, status) => {
        if (orderType == 'delivery' && !selectedAddress) {
            dispatch(showError(`${languageData['Please add delivery address'] ? languageData['Please add delivery address'] : 'Please add delivery address'}`));
        } else {
            dispatch(enableLoader());
            cartItems.map((item) => {
                item.category = item.category;
                item.categoryId = item.categoryId;
                item.type = keywords[PRODUCT];
                delete item.imagePaths
                const isDiscountExcluded = Boolean(item?.excludeFromDiscount);
                item.billingPrice = isDiscountExcluded ? item.price : (item.salePrice || item.price);
                item.fromPackage = 0
                item.fromMembership = 0
                item.fromGuestPackage = 0
            });
            let order: any = {
                "storeId": storeData.storeId,
                "tenant": storeData.tenant,
                "store": storeData.store,
                "tenantId": storeData.tenantId,
                "storeKey": storeData.storeKey,
                "guest": user.firstName,
                "guestId": user.id,
                "phone": user.mobileNo,
                "email": user.email,
                "remark": orderInstruction,
                "subtotal": pricingBreakdown.subTotal,
                "total": pricingBreakdown.total,
                "orderDay": new Date(),
                "createdOn": new Date(),
                "appointment": null,
                "products": cartItems,
                "type": orderType,
                "orderTime": `${new Date().getHours()}:${new Date().getMinutes()}`,
                "guestCountryCode": user.countryCode,
                "statuses": [
                    {
                        "state": ORDER_REQUESTED,
                        "staff": null,
                        "createdOn": new Date()
                    }
                ],
                "uniqueRecordIdentifier": uniqueRecordIdentifier
            }
            if (orderType == 'delivery') {
                order['address'] = selectedAddress;
            }

            localStorage.setItem("payment_type", `order-${status.toLowerCase()}`);
            switch (status.toLowerCase()) {
                case "pay_later":
                    // create regular pay later order
                    APISERVICE.POST(process.env.NEXT_PUBLIC_PLACE_ORDER, order).then((res) => {
                        setTimeout(() => {
                            // sendWhatsappMsg(user)
                            setOrderData(res.data)
                            setShowOrderConfirmation(true);
                            dispatch(disableLoader());
                            dispatch(updateCurrentPage('orderconfirmation'));
                            dispatch(replaceOrderIitems([]));
                        }, 1000)
                    }).catch((error) => {
                        console.error(error)
                        dispatch(disableLoader());
                        dispatch(showError(`${languageData['Order creation failed'] ? languageData['Order creation failed'] : 'Order creation failed'}`))
                    })
                    break;
                case "razorpay":
                    // create razor pay order
                    APISERVICE.POST(`${process.env.NEXT_PUBLIC_PLACE_ORDER}/rzr`, order).then((res) => {
                        setTimeout(() => {
                            const { Razorpay }: any = window;
                            const razorOptions = res.data
                            delete razorOptions.payment_link_id;
                            const rzp1 = new Razorpay(razorOptions);
                            rzp1.open();
                            dispatch(disableLoader());
                        }, 1000)
                    }).catch((error) => {
                        console.error(error)
                        dispatch(disableLoader());
                        dispatch(showError(`${languageData['Order creation failed'] ? languageData['Order creation failed'] : 'Order creation failed'}`))
                    })
                    break;
                case "ccavenue":
                    // create razor pay order
                    APISERVICE.POST(`${process.env.NEXT_PUBLIC_PCS_TXN}/ccavenue?env=test`, order).then((res) => {
                        setTimeout(() => {
                            window.open(res.data.redirctTo, "_self")
                            // setopenCcavenueModal({ active: true, link: res.data.redirctTo })
                            // dispatch(disableLoader());
                        }, 1000)
                    }).catch((error) => {
                        console.error(error)
                        dispatch(disableLoader());
                        dispatch(showError(`${languageData['Order creation failed'] ? languageData['Order creation failed'] : 'Order creation failed'}`))
                    })
                    break;
                case "stripe":
                    // create stripe order
                    APISERVICE.POST(`${process.env.NEXT_PUBLIC_STRIPE_PAYMENT}/add`, order).then((res: any) => {
                        order.id = res.data.orderId;
                        setOrderData(order);
                        const paymentAddress = {
                            area: storeMetaData.area,
                            city: storeMetaData.city,
                            country: storeMetaData.code,//used as country code // IN
                            code: storeMetaData.pincode,
                            landmark: storeMetaData.landmark,
                            latitude: storeMetaData.latitude,
                            line: storeMetaData.address,
                            longitude: storeMetaData.longitude,
                        }
                        setStripeModalDetails({
                            ...stripeModalDetails,
                            options: { ...stripeModalDetails.options, clientSecret: res.data.clientSecret },
                            paymentIntentId: res.data.paymentIntentId,
                            order,
                            address: orderType == 'delivery' ? selectedAddress : paymentAddress,
                            user: userData
                        });
                        dispatch(disableLoader());
                    }).catch((error) => {
                        console.error(error)
                        dispatch(disableLoader());
                        dispatch(showError(`${languageData['Order creation failed'] ? languageData['Order creation failed'] : 'Order creation failed'}`))
                    })
                    break;
                case "paystack":
                    APISERVICE.POST(`${process.env.NEXT_PUBLIC_PLACE_ORDER}/paystack`, order)
                        .then((res) => {
                            const response = res.data;
                            const { PaystackPop }: any = window;
                            const paystackOptions = {
                                key: response.publicKey,
                                email: response.email,
                                amount: response.amount,
                                ref: response.reference,
                                access_code: response.access_code,
                                callback: function (paymentResponse) {
                                    APISERVICE.POST(`${process.env.NEXT_PUBLIC_PCS_TXN}/paystack/verify`, { reference: paymentResponse.reference })
                                        .then((verifyRes) => {
                                            window.location.href = verifyRes.data.redirectUrl;
                                        })
                                        .catch(() => {
                                            dispatch(showError("Payment verification failed"));
                                        });
                                },
                                onClose: function () {
                                    dispatch(showError("Payment cancelled"));
                                }
                            };
                            const handler = PaystackPop.setup(paystackOptions);
                            handler.openIframe();
                            dispatch(disableLoader());
                        })
                        .catch((error) => {
                            console.error(error)
                            dispatch(disableLoader());
                            dispatch(showError(languageData['Order creation failed'] || 'Order creation failed'));
                        });
                    break;

                case "globalpayments":
                    APISERVICE.POST(`${process.env.NEXT_PUBLIC_PLACE_ORDER}/globalpayments`, order)
                        .then((res: any) => {
                            setGlobalPaymentsModalDetails({
                                accessToken: res.data.accessToken,
                                reference: res.data.reference
                            });
                            dispatch(disableLoader());
                            setTimeout(() => {
                                const { GlobalPayments }: any = window;
                                if (!GlobalPayments) {
                                    console.error("Global Payments SDK script is missing from window context.");
                                    return;
                                }
                                GlobalPayments.configure({
                                    accessToken: res.data.accessToken,
                                    apiVersion: "2021-03-22",
                                    env: process.env.NEXT_PUBLIC_ENVIRONMENT === "production" ? "production" : "sandbox"
                                });
                                const cardForm = GlobalPayments.creditCard.form("#global-payments-container", {
                                    style: "gp-default"
                                });
                                cardForm.ready(() => {
                                });
                                cardForm.on("token-success", (tokenResponse: any) => {
                                    dispatch(enableLoader());
                                    const extractedToken = tokenResponse.paymentReference;
                                    APISERVICE.POST(`${process.env.NEXT_PUBLIC_PCS_TXN}/globalpayments/verify`, { reference: res.data.reference, paymentToken: extractedToken })
                                        .then((verifyRes) => {
                                            window.location.href = verifyRes.data.redirectUrl;
                                        })
                                        .catch(() => {
                                            dispatch(disableLoader());
                                            dispatch(showError("Payment verification failed"));
                                        });
                                });
                                cardForm.on("token-error", (error: any) => {
                                    console.error("Global Payments UI exception rule triggered: ", error);
                                    let errMsg = "Card authorization validation failed";
                                    if (error.message) errMsg = error.message;
                                    else if (error.details && error.details.length > 0) {
                                        errMsg = `${error.details[0].field.replace("card-", "").toUpperCase()}: ${error.details[0].message}`;
                                    }
                                    dispatch(disableLoader());
                                    dispatch(showError(errMsg));
                                });
                            }, 600);
                        })
                        .catch((error) => {
                            console.error(error);
                            dispatch(disableLoader());
                            dispatch(showError(languageData['Order creation failed'] || 'Order creation failed'));
                        });
                    break;
            }
        }
    }

    const proceedToPayments = () => {
        setOpenPaymentVendorModal(false)
        if (paymentGatewayList?.length > 1) {
            //open paymode vendor selection modal
            setOpenPaymentVendorModal(true)
        } else {
            //redirect to payments screen
            proceedOrder(paymentGatewayList[0].name)
        }
    }

    const handlePaymentVendorSelection = (paymode) => {
        if (paymode) {
            proceedOrder(paymode.name)
        }
        setOpenPaymentVendorModal(false);
    }

    const proceedOrder = (status) => {
        if (configData?.orderingOn && !configData?.storeOff && !configData?.readOnlyMenu && (configData.deliveryOn || configData.pickupOn)) {
            if (userData) {
                createOrder(userData, status);
            }
        } else {
            setShowOrderingOff(true);
        }
    }

    const getUserDetails = (mobileNo) => {
        dispatch(enableLoader());
        return new Promise((res, rej) => {
            getUserByTenantAndMobile(storeData?.tenantId, storeData?.storeId, mobileNo).then((response: any) => {
                dispatch(disableLoader());
                if (!response) return;
                res(response.data);
            }).catch(function (error) {
                dispatch(disableLoader());
                rej(error);
                console.error("error")
            });
        });
    }

    const handleAddressModalResponse = (address) => {
        if (address) {
            const newAddress = { ...address };
            const userAddressesCopy = [...userAddresses];
            userAddressesCopy.map((userAdd) => {
                if (userAdd.type == newAddress.type) {
                    userAdd.value = address;
                }
            })
            setSelectedAddressType(address.type);
            setUserAddresses(userAddressesCopy);
            setSelectedAddress(newAddress)
        }
        setSelectedAddressToEdit(null);
        setOpenAddressModal(false)
    }

    const setActiveAddressType = (address) => {
        if (address.value) {
            setSelectedAddressType(address.type);
        } else {
            setSelectedAddressToEdit({ type: address.type })
            setOpenAddressModal(true);
        }
    }

    const editAddress = (address) => {
        setSelectedAddressToEdit(address);
        setOpenAddressModal(true);
    }

    const onUserUpdationClose = (userData) => {
        setOpenUserUpdationModal(false);
    }

    return (
        <div className="cart-page-wrap main-wrapper">
            {hasPaymentGateway("razorpay", paymentGatewayList) && (<Script src="https://checkout.razorpay.com/v1/checkout.js" strategy="lazyOnload" />)}
            {hasPaymentGateway("paystack", paymentGatewayList) && (<Script src="https://js.paystack.co/v1/inline.js" strategy="lazyOnload" />)}
            {hasPaymentGateway("globalpayments", paymentGatewayList) && (<Script src="https://js.globalpay.com/4.1.21/globalpayments.js" strategy="lazyOnload" />)}
            
            {!showOrderConfirmation ?
                <>
                    {cartItems.length != 0 ?
                        < div className='checkout-page-wrap clearfix'>
                            {/* <div className="page-heading">
                                <div className='icon' onClick={() => router.back()}><BiArrowBack /></div>
                                Order details
                            </div> */}
                            {userData && <div className="guest-details-wrap glass-card">
                                <div className='sub-heading'>{languageData["Guest Details"] ? languageData["Guest Details"] : "Guest Details"}</div>
                                <div className="username">{userData.firstName} {userData.lastName}</div>
                                <div className="usernumber">{basicConfig.multipleCountryCode ? "+" + userData.countryCode : ""} {userData.mobileNo}</div>
                                <div className="usernumber">{userData.email}</div>
                                <div className="edit-user-icon d-f-c" onClick={(e) => setOpenUserUpdationModal(true)}><FaUserEdit /></div>
                            </div>}

                            {/* order type --delivery/pickup */}
                            <div className="order-type-wrap glass-card">
                                <div className='sub-heading'>{languageData["Order Type"] ? languageData["Order Type"] : "Order Type"}</div>
                                <div className='order-type'>
                                    {configData?.deliveryOn && <div className={`type-btn ${orderType == 'delivery' ? 'active' : ''}`} onClick={() => setOrderType('delivery')}>
                                        <div className='icon-wrap'>
                                            <RiTakeawayLine />
                                        </div>
                                        {languageData["Delivery"] ? languageData["Delivery"] : "Delivery"}
                                    </div>}
                                    {configData?.pickupOn && <div className={`type-btn ${orderType == 'pickup' ? 'active' : ''}`} onClick={() => setOrderType('pickup')} >
                                        <div className='icon-wrap'>
                                            <MdDirectionsRun />
                                        </div>
                                        {languageData["Pickup"] ? languageData["Pickup"] : "Pickup"}
                                    </div>}
                                </div>
                            </div>
                            {(orderType == 'delivery') ? <div className="address-wrap glass-card">
                                <div className="sub-heading">{languageData["Delivery Address"] ? languageData["Delivery Address"] : "Delivery Address"}</div>
                                {userAddresses.map((address) => {
                                    return <div className={`add-type-details glass-card ${selectedAddressType == address.type ? 'active' : ''}`} key={Math.random()} onClick={() => setActiveAddressType(address)}>
                                        <div className="type-icon-wrap">
                                            <div className="icon-wrap d-f-c">{address.icon}</div>
                                            <div className="type-name">{address.type}</div>
                                        </div>
                                        {address.value && address.value.line ? <div className="address-details">
                                            <div className="line">{address.value.line}</div>
                                            <div className="line">
                                                {address.value.area && <>{address.value.area},</>}
                                                {address.value.city && <>{address.value.city},</>}
                                                {address.value.code && <>{address.value.code}</>}
                                            </div>
                                            <div className="edit-address-icon d-f-c" onClick={() => editAddress(address.value)}><MdEditLocation /></div>
                                        </div> :
                                            <div className="address-details">
                                                <div className="line">{languageData["No address saved yet"] ? languageData["No address saved yet"] : "No address saved yet"}</div>
                                                <div className="edit-address-icon d-f-c" onClick={() => setOpenAddressModal(true)}><MdAddLocation /></div>
                                            </div>
                                        }
                                    </div>
                                })}
                            </div>
                                :
                                <div className="address-wrap glass-card">
                                    <div className="sub-heading">{languageData["Pickup Address"] ? languageData["Pickup Address"] : "Pickup Address"}</div>
                                    <div className='add-type-details glass-card active'>
                                        <div className="type-icon-wrap">
                                            <div className="icon-wrap d-f-c"><GrFormLocation /></div>
                                            <div className="type-name">{storeMetaData?.name}</div>
                                        </div>
                                        <div className="address-details">
                                            <div className="line">{storeMetaData?.address}, {storeMetaData?.city}, {storeMetaData?.state}, {storeMetaData?.pincode}</div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="summary-details-wrap glass-card">
                                <div className='sub-heading'>{languageData["Bill Details"] ? languageData["Bill Details"] : "Bill Details"}</div>
                                <div className='cart-items-list'>
                                    {cartItems?.map((item, i) => {
                                        return <div className="item-details clearfix" key={Math.random()}>
                                            <div className="item-name">{i + 1}. {item.languages && item.languages[activeLanguage?.languageId]?.name ? item.languages[activeLanguage?.languageId]?.name : item.name} ({item.quantity})</div>
                                            <div className="item-price">{configData.currencySymbol} {(Boolean(item?.excludeFromDiscount) ? item.price : (item.salePrice || item.price))}</div>
                                        </div>
                                    })}
                                </div>
                                <div className='total-wrap'>
                                    <div className='price-wrap'>
                                        <div className='type'>{languageData["Subtotal"] ? languageData["Subtotal"] : "Subtotal"}</div>
                                        <div className='value'>{configData.currencySymbol} {pricingBreakdown.subTotal}</div>
                                    </div>
                                    {pricingBreakdown.appliedTaxes?.map((taxData: any, i: number) => {
                                        return <div className='price-wrap' key={Math.random()}>
                                            <div className='type'>{taxData.name}{taxData.isInclusive ? `${languageData["(Inclusive)"] ? languageData["(Inclusive)"] : "(Inclusive)"}` : ''}({taxData.value}%)</div>
                                            <div className='value'>{configData.currencySymbol} {taxData.total}</div>
                                        </div>
                                    })}
                                    <div className='price-wrap grand-total'>
                                        <div className='type'>{languageData["Grand Total"] ? languageData["Grand Total"] : "Grand Total"}</div>
                                        <div className='value'>{configData.currencySymbol} {pricingBreakdown.total}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="instruction-details-wrap glass-card">
                                <div className='sub-heading'>{languageData["Order Instruction"] ? languageData["Order Instruction"] : "Order Instruction"}</div>
                                <input value={orderInstruction} maxLength={180} placeholder={languageData["Add Instruction(Optional)"] ? languageData["Add Instruction(Optional)"] : "Add Instruction(Optional)"} className="instlab" onChange={(e) => setOrderInstruction(e.target.value)} />
                            </div>

                            <div className="order-btns-wrap">
                                <div className="order-btns clearfix">
                                    {configData?.recieveOnlinePayment && paymentGatewayList?.length && <div className="proceedbtn" onClick={() => proceedToPayments()}>{languageData["Pay now"] ? languageData["Pay now"] : "Pay now"} </div>}
                                    {configData?.cod && <>
                                        {(orderType == 'pickup' || configData?.codForDeliveryOrders) && <div className="proceedbtn" onClick={() => proceedOrder('pay_later')}>{configData?.codForDeliveryOrders ? `${languageData["Cash On Delivery"] ? languageData["Cash On Delivery"] : "Cash On Delivery"}` : `${languageData["Pay at the counter"] ? languageData["Pay at the counter"] : "Pay at the counter"}`}</div>}
                                    </>}
                                </div>
                            </div>
                        </div>
                        :
                        // CART IS EMPTY
                        <div className="emptyCart-main-wrap">
                            <div className="emptyCart-wrap">
                                <div><img className="cart-logo" src={`/assets/images/${activeGroup}/cart.png`} alt="Respark" /></div>
                                <div className="cart-status">{languageData["CART IS EMPTY"] ? languageData["CART IS EMPTY"] : "CART IS EMPTY"}</div>
                                <div className="cart-subtext">{languageData["You don't have any item in cart"] ? languageData["You don't have any item in cart"] : "You don't have any item in cart"}</div>
                                <div><button className="cart-button" onClick={handleOrderConfirmationMOdalResponse}>{languageData["Explore More"] ? languageData["Explore More"] : "Explore More"}</button></div>
                            </div>
                        </div>
                    }
                </>
                :
                <OrderConfirmation inititalOrder={orderData} />
            }

            <Backdrop
                className="backdrop-modal-wrapper"
                open={openCcavenueModal.active ? true : false}
                onClick={() => setopenCcavenueModal({ active: false, link: "" })}
            >
                <div className="backdrop-modal-content"
                    style={{ height: `80vh` }}
                >
                    <div className="heading" >{languageData["Pay Amount"] ? languageData["Pay Amount"] : "Pay Amount"}</div>
                    <div className="modal-close" onClick={() => setopenCcavenueModal({ active: false, link: "" })}>
                        <IconFrame><CloseIcon /></IconFrame>
                    </div>
                    <div className='pricing-details-wrap d-f-c'>
                        <iframe src={openCcavenueModal.link} width="400" height="300"></iframe>
                    </div>
                </div>
            </Backdrop>

            <Backdrop
                className="backdrop-modal-wrapper"
                open={showTotalBreakdownPopup ? true : false}
                onClick={() => setShowTotalBreakdownPopup(false)}
            >
                <div className="backdrop-modal-content"
                    style={{ height: `${showTotalBreakdownPopup ? `${140 + (pricingBreakdown?.appliedTaxes?.length * 30)}px` : '0'}` }}
                >
                    <div className="heading" >{languageData["Pricing Details"] ? languageData["Pricing Details"] : "Pricing Details"}</div>
                    <div className="modal-close" onClick={() => setShowTotalBreakdownPopup(false)}>
                        <IconFrame><CloseIcon /></IconFrame>
                    </div>
                    <div className='pricing-details-wrap d-f-c'>
                        <div className='heading'>
                            <div className='line'>{languageData["SubTotal"] ? languageData["SubTotal"] : "SubTotal"}</div>
                            {pricingBreakdown.appliedTaxes?.map((taxData: any, i: number) => {
                                return <div className='title' key={Math.random()}>{taxData.name}{taxData.isInclusive ? "(Inclusive)" : ''}({taxData.value}%)</div>
                            })}
                            <div className='title grand-total'>{languageData["Grand Total"] ? languageData["Grand Total"] : "Grand Total"}</div>
                        </div>
                        <div className='details'>
                            <div className='value'>{configData.currencySymbol} {pricingBreakdown.subTotal}</div>
                            {pricingBreakdown.appliedTaxes?.map((taxData: any, i: number) => {
                                return <div className='value' key={Math.random()}>{configData.currencySymbol} {taxData.total}</div>
                            })}
                            <div className='value grand-total'>{configData.currencySymbol} {pricingBreakdown.total}</div>
                        </div>
                    </div>
                </div>
            </Backdrop>

            {openUserUpdationModal && <UserRegistrationModal
                handleResponse={(e) => onUserUpdationClose(e)}
                isApppGrpChangeOnUserGdrChange={true}
                open={true}
                fromPage={'PROFILE'}
                heading={languageData['Update Profile Details'] ? languageData['Update Profile Details'] : 'Update Profile Details'}
            />}
            <ConfirmationModal
                openModal={showOrderingOff}
                title={languageData['Ordering confirmation'] ? languageData['Ordering confirmation'] : 'Ordering confirmation'}
                message={'Currently we are unserviceable'}
                buttonText={'OK'}
                handleClose={() => setShowOrderingOff(false)}
            />
            <AddressModal
                open={openAddressModal}
                handleClose={(res) => handleAddressModalResponse(res)}
                addressToEdit={selectedAddressToEdit}
                userId={userData?.id}
            />

            <PaymentVendorModal
                open={openPaymentVendorModal}
                handleClose={(e: any) => handlePaymentVendorSelection(e)}
                paymentGatewayList={paymentGatewayList} />

            <StripePaymentModal
                stripeModalDetails={stripeModalDetails}
                setStripeModalDetails={setStripeModalDetails}
                title={languageData["Pay Here"] ? languageData["Pay Here"] : "Pay Here"}
                showCloseButton
            />

            {globalPaymentsModalDetails.accessToken ? (
                <Backdrop className="backdrop-modal-wrapper" open={!!globalPaymentsModalDetails.accessToken}>
                    {/* ⚡ FIX: Changed stripe-modal-content to globalpayments-modal-content and removed the static inline height constraint */}
                    <div className="backdrop-modal-content globalpayments-modal-content">
                        <div className="modal-close" onClick={() => setGlobalPaymentsModalDetails({ accessToken: "", reference: "" })}>
                            <IconFrame><CloseIcon /></IconFrame>
                        </div>
                        <div className="heading">{languageData["Pay Here"] ? languageData["Pay Here"] : "Pay Here"}</div>

                        {/* The core secure elements mount canvas container for Global Payments script */}
                        <div id="global-payments-container" style={{ padding: '16px 8px' }}></div>
                    </div>
                </Backdrop>
            ) : null}
        </div>
    )
}

export default CheckoutPage
